var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 64,
    y1: 0,
    x2: -0.01,
    y2: 64.011
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d2",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 31.917,
    cy: 31.917,
    r: 24.415
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d4",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    points: "7.516,53.139 32.01,10.716  56.505,53.139  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d6",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.845,
    y: 10.845,
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    width: 42.311,
    height: 42.311
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "d8"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "5.636,48.377 31.992,0.895  58.347,48.377  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "58.347,48.377 31.992,0.895  58.427,17.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#333333",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "5.636,48.377 58.347,48.377  31.992,63.098  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "5.636,48.377 5.563,17.672  31.992,0.895  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "d10",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.992,1.812  11.864,40.387 31.992,49.923 52.119,40.387  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "52.119,40.387  31.992,1.812 63.064,25.293 63.064,40.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#333333",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.992,62.19  31.992,49.923 52.119,40.387 63.064,40.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "11.864,40.387  31.992,1.812 0.918,25.293 0.918,40.036  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#333333",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.992,62.19  31.992,49.923 11.864,40.387 0.918,40.036  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "d12",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "32,11.935  13.646,25.38 20.368,47.512 43.632,47.512 50.354,25.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#666766",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "43.632,47.512  50.354,25.38 60.853,21.831 60.853,41.318 50.203,56.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "50.354,25.38  32,11.935 32,0.833 49.07,6.498 60.853,21.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "32,11.935  13.646,25.38 3.146,21.831 14.93,6.498 32,0.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#666766",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "13.646,25.38  20.368,47.512 13.796,56.65 3.146,41.318 3.146,21.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#333333",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "20.368,47.512  43.632,47.512 50.203,56.65 32,63.146 13.796,56.65  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "d20",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#666766",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,63.007  58.358,45.563 49.049,45.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "49.049,45.563  58.358,18.086 58.358,45.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,14.291  31.966,0.914 58.358,18.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#CCCCCC",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,14.291  49.049,45.563 58.358,18.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#666766",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,63.007  5.574,45.563 14.884,45.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "14.884,45.563  5.574,18.086 5.574,45.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#999999",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,14.291  31.966,0.914 5.574,18.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#CCCCCC",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,14.291  14.884,45.563 5.574,18.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "14.884,45.563  31.966,14.291 49.049,45.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#333333",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "31.966,63.007  14.884,45.563 49.049,45.563  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD8);
export default __webpack_public_path__ + "static/media/d8.55d127935211cf94af9bb34d02c2655d.svg";
export { ForwardRef as ReactComponent };